import React, { useState, useLayoutEffect, useEffect } from 'react';
import { IconButton, Icons } from '@curves/ui-base';
import clsx from 'clsx';

const ScrollerArrowButton = (props) => {
    const { parentRef, arrowLeftPos = 0, arrowRightPos = 0, moveDistance = 300 } = props;
    const [showRight, setShowRight] = useState(false);
    const [showLeft, setShowLeft] = useState(false);
    const [isMounted, setMounted] = useState(false);
    const leftPos = arrowLeftPos === 0 ? {} : { left: arrowLeftPos * 1 };
    const rightPos = arrowRightPos === 0 ? {} : { right: arrowRightPos * 1 };
    const handleClickScrollToLeft = () => {
        if (!parentRef.current) return;
        parentRef.current.scrollLeft -= moveDistance;
    };
    const handleClickScrollToRight = () => {
        if (!parentRef.current) return;
        parentRef.current.scrollLeft += moveDistance;
    };
    const handleOnScroll = () => {
        if (!parentRef.current && !isMounted) return;
        const { scrollLeft, clientWidth, scrollWidth: max } = parentRef.current;
        const pos = scrollLeft + clientWidth;
        if (scrollLeft === 0) setShowLeft(false);
        else if (pos === max) setShowRight(false);
        else {
            setShowLeft(true);
            setShowRight(true);
        }
    };
    // 監聽寬度是否有變化
    const handleResizeObserver = () => {
        const observer = new ResizeObserver(() => {
            if (!parentRef.current && !isMounted) return;
            const { scrollWidth, clientWidth } = parentRef.current;
            if (scrollWidth === clientWidth) setShowRight(false);
            else setShowRight(true);
        });
        observer.observe(parentRef.current);
        return observer;
    };
    useLayoutEffect(
        () => {
            if (!parentRef.current) return;
            const node = parentRef.current;
            node.classList.add('scroll-arrow-wrap');
            node.addEventListener('scroll', handleOnScroll);
            const observer = handleResizeObserver();
            return () => {
                node.removeEventListener('scroll', handleOnScroll);
                observer && observer.disconnect();
            };
        },
        // eslint-disable-next-line
        []
    );
    useEffect(() => {
        setMounted(true);
        return () => {
            setMounted(false);
        };
        // eslint-disable-next-line
    }, []);
    return (
        <React.Fragment>
            <div style={{ ...leftPos }} className={clsx('scroller-left-button', !showLeft && 'hidden')}>
                <IconButton className="arrow-button" onClick={handleClickScrollToLeft}>
                    <Icons.NavigateBefore />
                </IconButton>
            </div>
            <div style={{ ...rightPos }} className={clsx('scroller-right-button', !showRight && 'hidden')}>
                <IconButton className="arrow-button" onClick={handleClickScrollToRight}>
                    <Icons.NavigateNext />
                </IconButton>
            </div>
        </React.Fragment>
    );
};
export default ScrollerArrowButton;
